import Image from 'next/image';
import React, { useEffect, useState } from 'react';
import { deleteIcon } from '../../../public/assets/icons';

import {
  errorIcon,
  notificationIcon,
  successCheckIcon,
  warnIcon,
} from '../../../public/assets/images';

const Alert = ({ message, type }) => {
  const handleIcon = type => {
    switch (type) {
      case 'error':
        return errorIcon;
      case 'success':
        return successCheckIcon;
      case 'info':
        return notificationIcon;
      case 'warn':
        return warnIcon;
      default:
        return successCheckIcon;
    }
  };

  const handleClassName = type => {
    switch (type) {
      case 'error':
        return 'border-error-75 bg-error-50';
      case 'success':
        return 'border-secondary bg-secondary-50';
      case 'info':
        return 'border-info-bg bg-info';
      case 'warn':
        return 'border-warn-75 bg-warn-50';
      default:
        return 'success';
    }
  };

  return (
    message &&
    type && (
      <div className="w-full alert-anim my-2">
        <div className={`border ${handleClassName(type)} rounded-lg p-3  mb-2`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-center ">
              <div className="flex items-center justify-center">
                <Image
                  src={handleIcon(type)}
                  height={20}
                  width={20}
                  alt="Stakecut | Onstop Affiliate Marketplace"
                />
              </div>
              <div className="ml-4">
                <p className="text-sm">{message || 'This is an alert'}</p>
              </div>
            </div>

            <button className="items-center justify-center flex hover:bg-red-100 rounded-full p-2 transition-all duration-500 ease-in-out">
              <Image
                src={deleteIcon}
                height={15}
                width={15}
                alt="Stakecut | Onstop Affiliate Marketplace"
              />
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default Alert;
